import { useEffect, useState } from 'react'

const DESKTOP_WIDTH = 1024

export function useIsDesktop() {
  const [isDesktop, setIsDesktop] = useState(() => {
    if (typeof window === 'undefined') {
      return true
    }
    return window.innerWidth >= DESKTOP_WIDTH
  })

  useEffect(() => {
    const update = () => setIsDesktop(window.innerWidth >= DESKTOP_WIDTH)
    update()
    window.addEventListener('resize', update)
    return () => window.removeEventListener('resize', update)
  }, [])

  return isDesktop
}
